import React from 'react'
import { Box, Container, Fade, Grid, Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import useQueryState from '@components/useQueryState'
import SearchTextField from '@imports/SearchTextField'
import { useHelpArticles } from '@api/helpCenter'
import ArticleSearchResult from './components/ArticleSearchResult'

function HelpCenterLayout({ children }) {
  const { t } = useTranslation(['common', 'help-center'])
  const { locale } = useRouter()

  const [q, setQ] = useQueryState('q', { defaultValue: '', type: 'string' })
  const helpArticleQuery = useHelpArticles({ locale, q })

  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      <Box
        sx={{ backgroundColor: 'primary.main', color: 'primary.contrastText' }}
        py={10}
      >
        <Container maxWidth="md">
          <Grid
            container
            spacing={5}
            textAlign="center"
          >
            <Grid
              item
              xs={12}
            >
              <Typography
                variant="h3"
                display="block"
                textTransform="capitalize"
              >
                {t('common:Blue_Assembly')} {t('help-center:help_center')}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
            >
              <Typography
                variant="h6"
                display="block"
                sx={{ pb: 3 }}
                fontWeight={300}
              >
                {t('help-center:Have_any_questions')}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
            >
              <SearchTextField
                fullWidth
                placeholder={t('common:search')}
                size="small"
                searchState={[q, setQ]}
                backgroundColor="white"
                isLoading={helpArticleQuery.isRefetching}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Fade
        in={!q}
        sx={{ display: !q ? '' : 'none' }}
      >
        <Box>{children}</Box>
      </Fade>
      <Fade
        in={!!q}
        sx={{ display: q ? '' : 'none' }}
      >
        <Box>
          <ArticleSearchResult data={helpArticleQuery.data} />
        </Box>
      </Fade>
    </Box>
  )
}

export default HelpCenterLayout
